<template>
  <div class="flex flex-col h-full overflow-hidden font-[Cubic]">
    <ThreadsNav show-back :show-center="false" />
    <div class="flex-1 overflow-hidden">
      <MissionJourneyList />
    </div>
  </div>
</template>
